<template>
  <div>

    <div class="title-section">
      <div class="display-1 font-weight-bold">{{meta.title}}</div>
      <div class="subheading">{{meta.subtitle}}</div>
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Design</div><v-divider class="div-after"/>
    <div class="body-1">
      Following work on checkpoint 3 (illumination), I decided to go back and refine the 
      framework's design a little further! Mostly minor changes, some new
      or adjusted relationships between classes. I've also broken the 
      framework down into three major concerns: entity, scene and utility. 
    </div>
    <div class="body-1">
      Not everything is up and running just yet, there are quite a few placeholders.
      Cross-subsystem relationships have not been captured here, primarily to avoid
      the clutter of the previous class diagram. 
    </div>
    <v-img class="u-image-large" :src="require(`../assets/updates/6/updated_framework.png`)"/>
      <div class="font-weight-medium">Refined Framework</div>
    <v-divider class="spacer"/><div class="headline font-weight-bold">Key Changes</div><v-divider class="div-after"/>
    <card-list :items="key_changes"/>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Next Steps</div><v-divider class="div-after"/>
    <div class="body-1">
      With the completion of this checkpoint, I do have a variety of improvements
      to make to the implementation, as well as some expanded design concerns.
    </div>
    <card-list :items="next_steps"/>


  </div>
</template>

<script>
import CardList from '../components/CardList';

export default {
  name: 'U_6',
  components: { CardList, },
  data() {
    return {
      key_changes: [
        {title: "Model Transformations", desc: "Hey, you can adjust the scale/rotation of entities now! " +
        "At least, according to the Entity interface. "},
        {title: "Primitives & Models", desc: "The primitive interface has \"silent\" methods for use with " +
        "a parent mesh, just so that a large polygonal mesh doesn't ping the EntityMediator a bunch of times."},
        {title: "Entity Mediator", desc: "Potentially temporary, but responsible for holding all entities, " +
        "sorting them by type and determining whether or not the scene needs to be rendered again. "},
        {title: "Patterns, Patterns, Patterns", desc: "Observer pattern (ignore the Mediator name) will be useful " +
        "for managing all the updates from various Entities to the Scene when their properties change and we determine " +
        "that the scene needs to be rendered again. The Scene has pretty much become a Facade, the Composite pattern " + 
        "can make applying multiple materials to the same object fairly painless. Strategy pattern is pretty much everywhere. "},
        {title: "Ray, Hit and Radiance", desc: "At the moment, I've removed Radiance from the design. It'll likely " +
        "reappear, but I'm keeping things a little simpler for now (at the risk of future refactoring). Ray and Hit have " + 
        "some minor adjustments, but the key changes were primarily made to Hit. We'll need a reference to the Scene in order " + 
        "to determine what lights are impacting the hitpoint."}
      ],
      next_steps: [
        {title: "Textures", desc: "Texture mapping and the use of procedural texturing will be key " +
        "for the next checkpoint, though I also wish to support the importing of texture files."},
        {title: "K-D Trees & Meshes", desc: "I'll be adding support for meshes and K-D trees. Stanford bunny incoming!"},
        {title: "Cook-Torrance", desc: "Daunting, but exciting!"},
        {title: "Photon Mapping", desc: "Fitting this into the design is fairly simple, as it's just another step " +
        "in the RayTracer. The supporting effort that'll go into actually tracing photons throughout the scene " + 
        "is going to be interesting. Hopefully I'll be able to leverage my existing design for some of this effort!"},
        {title: "Dynamic Scenes", desc: "Implementing a Scene class that passes down delta-time " +
        "updates to all dynamic entities. This'll be fun, and hopefully allow for some cool renders."},
        {title: "Entity Attributes", desc: "Having an extensible way to pass modifiable attributes " +
        "up to the UI and back down to the entities would be really really nice."},
        {title: "Expanded Lighting", desc: "Point lights are cool, but I'm really interested in adding " +
        "other types of lighting to the ray tracer as well!"},
        {title: "Post Processing", desc: "At the moment, I'm applying linear post processing to the image " +
        "and calling it a day. Eyes don't really work that way, so I'll be looking into better post processing techniques."},
        {title: "Antialiasing", desc: "Either through post processing or super sampling."},
        {title: "Change of Tech", desc: "I'm looking into potentially rewriting the current implementation in " + 
        "C++! It shouldn't be too time consuming, with most of the effort being spent on changing any math-stuff " + 
        "to match the syntax of whatever libraries I'll need. "},
        {title: "Final UI", desc: "At the moment, my idea for a finalized UI is simply one that displays a list " + 
        "of known entities and a context-dependent menu/location for displaying entity attributes. I'd love for it " + 
        "to update in real-time with dynamic scenes, though that's a bit of a stretch. Having the UI know about various " + 
        "scene attributes and understand how to change those attributes is pretty useful in testing! I've got a very rough " + 
        "UI built that mimics this behavior in an unpleasantly hardcoded way, though it's made testing a ton easier."}
      ]
    };
  },
  computed: {
    meta() {
      return this.$store.state.updates[6];
    },
  },
}
</script>

<style>

</style>
